<template>
  <span
    class="tw-inline-flex tw-aspect-[1/1] tw-h-[16px] tw-w-[16px] tw-items-center tw-justify-center tw-leading-none xs2:tw-h-[14px] xs2:tw-w-[14px] md:tw-h-[16px] md:tw-w-[16px]"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      class="tw-h-full tw-w-full"
    >
      <path
        d="M14.4326 13.75C14.3887 13.826 14.3256 13.8891 14.2496 13.933C14.1735 13.9769 14.0873 14 13.9995 14H1.99949C1.91176 13.9999 1.82561 13.9767 1.74967 13.9328C1.67373 13.8889 1.61068 13.8258 1.56686 13.7498C1.52304 13.6738 1.49998 13.5876 1.5 13.4999C1.50002 13.4121 1.52312 13.326 1.56699 13.25C2.51886 11.6044 3.98574 10.4244 5.69761 9.86499C4.85084 9.3609 4.19295 8.59279 3.82498 7.67861C3.457 6.76444 3.39929 5.75474 3.6607 4.80459C3.92211 3.85444 4.48819 3.01636 5.272 2.41907C6.05582 1.82178 7.01403 1.49829 7.99949 1.49829C8.98494 1.49829 9.94316 1.82178 10.727 2.41907C11.5108 3.01636 12.0769 3.85444 12.3383 4.80459C12.5997 5.75474 12.542 6.76444 12.174 7.67861C11.806 8.59279 11.1481 9.3609 10.3014 9.86499C12.0132 10.4244 13.4801 11.6044 14.432 13.25C14.476 13.3259 14.4992 13.4121 14.4993 13.4999C14.4994 13.5877 14.4764 13.6739 14.4326 13.75Z"
        fill="#374151"
      />
    </svg>
  </span>
</template>
<script>
export default {
  name: 'Occupied',
};
</script>
